(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["promo-code"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-promo-copy]');
    if (!btn) return;

    const code = btn.dataset.code;
    try {
      await navigator.clipboard.writeText(code);
    } catch (e) {
      const ta = document.createElement('textarea');
      ta.value = code;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      ta.remove();
    }

    btn.textContent = btn.dataset.copied;
    btn.classList.add('is-copied');
    clearTimeout(btn._t);
    btn._t = setTimeout(() => {
      btn.textContent = btn.dataset.label;
      btn.classList.remove('is-copied');
    }, 2000);
  });
  } catch(e) { console.error(e); }
})();

})();
